const selectors = {
    stockistSections: '[data-stockists]',
    searchForm: '.stockist-search-form',
    searchFilters: '.stockist-search-filters',
};
const classes = {
    customToggle: 'stockist-search-filter-toggle',
    toggleFilters: 'stockist-search-filters--show',
};
const stockists = () => {
    const stockistSections = document.querySelectorAll(selectors.stockistSections);
    stockistSections.forEach((section) => {
        const observerPlaceholder = section.querySelector('[data-stockist-widget-tag]');
        const searchForm = section.querySelector(selectors.searchForm);
        const searchFilters = section.querySelector(selectors.searchFilters);
        const applyCustomToggle = (searchForm, searchFilters) => {
            const customToggle = document.createElement('div');
            customToggle.classList.add(classes.customToggle);
            customToggle.innerHTML = 'Filter by Product';
            searchForm.append(customToggle);
            customToggle.addEventListener('click', () => {
                searchFilters.classList.toggle(classes.toggleFilters);
            });
        };
        if (searchForm && searchFilters) {
            applyCustomToggle(searchForm, searchFilters);
        }
        else {
            const observerConfig = { childList: true, subtree: true };
            const observerCallback = (mutationsList, observer) => {
                const searchForm = section.querySelector(selectors.searchForm);
                const searchFilters = section.querySelector(selectors.searchFilters);
                if (searchForm && searchFilters) {
                    applyCustomToggle(searchForm, searchFilters);
                    observer.disconnect();
                }
            };
            const observer = new MutationObserver(observerCallback);
            if (observerPlaceholder) {
                observer.observe(observerPlaceholder, observerConfig);
            }
        }
    });
};
export { stockists };
